import { c as _c } from "react/compiler-runtime";
import { LocaleEnum } from '@systemeio/ui';
import { useMemo } from 'react';
import { UserWorkspaceRolesEnum } from '@systemeio/types';
import { getLanguageCodeByLocale } from 'shared/enums/language-code-enum';
import { AdminRolesEnum, UserRolesEnum } from 'shared/enums/user-roles-enum';
import { UserInterface } from 'shared/types/user-interface';
import { hasWorkspaces } from '../utils/has-workspaces';
import { AvailablePlansEnum } from 'modules/profile/user-plan/enums/user-plan-type-enum';
export const useUserStatus = dashboardUser => {
  const $ = _c(41);
  let t0;
  if ($[0] !== dashboardUser?.roles) {
    t0 = dashboardUser?.roles.includes(UserRolesEnum.customer) || false;
    $[0] = dashboardUser?.roles;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isCustomer = t0;
  let t1;
  if ($[2] !== dashboardUser?.roles) {
    t1 = dashboardUser?.roles.includes(UserRolesEnum.affiliate) || false;
    $[2] = dashboardUser?.roles;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isAffiliate = t1;
  let t2;
  if ($[4] !== dashboardUser?.roles) {
    t2 = dashboardUser?.roles.includes(UserRolesEnum.student) || false;
    $[4] = dashboardUser?.roles;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isStudent = t2;
  const isWorkspaceOwner = dashboardUser ? dashboardUser.workspaceOwner === null : false;
  const isRootAdmin = dashboardUser?.id === 161 || dashboardUser?.workspaceOwner === 161;
  const isWhiteLabelOwner = dashboardUser?.hasWhiteLabel && !isRootAdmin || false;
  const isSupportImpersonation = !!dashboardUser?.impersonator && dashboardUser.impersonator.id !== dashboardUser.mainUser?.user.id;
  const isSubAccountImpersonation = dashboardUser?.id !== dashboardUser?.mainUser?.user.id;
  let t3;
  if ($[6] !== dashboardUser?.roles) {
    t3 = adminRoles => (adminRoles || Object.values(AdminRolesEnum)).filter(el => dashboardUser?.roles.includes(el)).length !== 0;
    $[6] = dashboardUser?.roles;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const checkAdminRoles = t3;
  let t4;
  if ($[8] !== dashboardUser?.impersonator?.roles) {
    t4 = adminRoles_0 => (adminRoles_0 || Object.values(AdminRolesEnum)).filter(el_0 => dashboardUser?.impersonator?.roles.includes(el_0)).length !== 0;
    $[8] = dashboardUser?.impersonator?.roles;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const checkImpersonatorAdminRoles = t4;
  let t5;
  if (!isWorkspaceOwner && dashboardUser && hasWorkspaces(dashboardUser)) {
    let t6;
    if ($[10] !== dashboardUser.workspaceMemberships || $[11] !== dashboardUser.workspaceOwner) {
      let t7;
      if ($[13] !== dashboardUser.workspaceOwner) {
        t7 = el_1 => el_1.workspaceOwner.id === dashboardUser.workspaceOwner;
        $[13] = dashboardUser.workspaceOwner;
        $[14] = t7;
      } else {
        t7 = $[14];
      }
      t6 = dashboardUser.workspaceMemberships.find(t7);
      $[10] = dashboardUser.workspaceMemberships;
      $[11] = dashboardUser.workspaceOwner;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    const workspace = t6;
    t5 = workspace ? workspace.role === UserWorkspaceRolesEnum.workspaceAdmin : false;
  } else {
    t5 = false;
  }
  const isWsAdmin = t5;
  let t6;
  if (!isWorkspaceOwner && dashboardUser && hasWorkspaces(dashboardUser)) {
    let t7;
    if ($[15] !== dashboardUser.workspaceMemberships || $[16] !== dashboardUser.workspaceOwner) {
      let t8;
      if ($[18] !== dashboardUser.workspaceOwner) {
        t8 = el_2 => el_2.workspaceOwner.id === dashboardUser.workspaceOwner;
        $[18] = dashboardUser.workspaceOwner;
        $[19] = t8;
      } else {
        t8 = $[19];
      }
      t7 = dashboardUser.workspaceMemberships.find(t8);
      $[15] = dashboardUser.workspaceMemberships;
      $[16] = dashboardUser.workspaceOwner;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    const workspace_0 = t7;
    t6 = workspace_0 ? workspace_0.role === UserWorkspaceRolesEnum.workspaceAssistant : false;
  } else {
    t6 = false;
  }
  const isWsAssistant = t6;
  let t7;
  if ($[20] !== dashboardUser?.dashboardLocale) {
    t7 = () => getLanguageCodeByLocale(dashboardUser?.dashboardLocale ?? LocaleEnum.ENGLISH);
    $[20] = dashboardUser?.dashboardLocale;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  dashboardUser?.dashboardLocale;
  let t8;
  if ($[22] !== t7) {
    t8 = t7();
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const intlLocale = t8;
  const isRestrictedUser = dashboardUser?.accessRestricted && isWorkspaceOwner;
  const isFreemium = (dashboardUser && dashboardUser.userPlanId === AvailablePlansEnum.freemium) === true;
  const isPaid = isFreemium === false;
  let t9;
  if ($[24] !== checkAdminRoles || $[25] !== checkImpersonatorAdminRoles || $[26] !== intlLocale || $[27] !== isAffiliate || $[28] !== isCustomer || $[29] !== isFreemium || $[30] !== isPaid || $[31] !== isRestrictedUser || $[32] !== isRootAdmin || $[33] !== isStudent || $[34] !== isSubAccountImpersonation || $[35] !== isSupportImpersonation || $[36] !== isWhiteLabelOwner || $[37] !== isWorkspaceOwner || $[38] !== isWsAdmin || $[39] !== isWsAssistant) {
    t9 = {
      isCustomer,
      isAffiliate,
      isStudent,
      isWsAdmin,
      isWhiteLabelOwner,
      isWsAssistant,
      isWorkspaceOwner,
      isRootAdmin,
      isSubAccountImpersonation,
      isSupportImpersonation,
      checkAdminRoles,
      checkImpersonatorAdminRoles,
      intlLocale,
      isRestrictedUser,
      isFreemium,
      isPaid
    };
    $[24] = checkAdminRoles;
    $[25] = checkImpersonatorAdminRoles;
    $[26] = intlLocale;
    $[27] = isAffiliate;
    $[28] = isCustomer;
    $[29] = isFreemium;
    $[30] = isPaid;
    $[31] = isRestrictedUser;
    $[32] = isRootAdmin;
    $[33] = isStudent;
    $[34] = isSubAccountImpersonation;
    $[35] = isSupportImpersonation;
    $[36] = isWhiteLabelOwner;
    $[37] = isWorkspaceOwner;
    $[38] = isWsAdmin;
    $[39] = isWsAssistant;
    $[40] = t9;
  } else {
    t9 = $[40];
  }
  return t9;
};